import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { translations, WHATSAPP_URL_ES, WHATSAPP_URL_EN } from "./translations";

const LanguageContext = createContext(null);

const STORAGE_KEY = "pt-lang";

export const LanguageProvider = ({ children }) => {
    const [lang, setLangState] = useState("es");

    useEffect(() => {
        const stored = typeof window !== "undefined" ? window.localStorage.getItem(STORAGE_KEY) : null;
        if (stored === "es" || stored === "en") {
            setLangState(stored);
        }
    }, []);

    useEffect(() => {
        if (typeof document !== "undefined") {
            document.documentElement.lang = lang === "es" ? "es-MX" : "en";
        }
    }, [lang]);

    const setLang = useCallback((next) => {
        setLangState(next);
        if (typeof window !== "undefined") {
            window.localStorage.setItem(STORAGE_KEY, next);
        }
    }, []);

    const value = useMemo(() => {
        const t = translations[lang];
        const waUrl = lang === "es" ? WHATSAPP_URL_ES : WHATSAPP_URL_EN;
        return { lang, setLang, t, waUrl };
    }, [lang, setLang]);

    return (
        <LanguageContext.Provider value={value}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLang = () => {
    const ctx = useContext(LanguageContext);
    if (!ctx) throw new Error("useLang must be used within LanguageProvider");
    return ctx;
};
